import { Action } from 'redux'
import { AuthorizationActions } from '../../../reducers/userAccount/actionNames'

export const resetPasswordEmail = (email: string) => ({
  type: AuthorizationActions.ResetPasswordEmail,
  email: email,
})

export const authorize = (
  username: string,
  password: string,
): IRequestAuthorize => ({
  password,
  type: AuthorizationActions.RequestAuthorization,
  username,
})

export default authorize

export interface IRequestAuthorize
  extends Action<AuthorizationActions.RequestAuthorization> {
  password: string
  username: string
}

export const authorizationRejected = (): Action<
  AuthorizationActions.AuthorizationRejected
> => ({
  type: AuthorizationActions.AuthorizationRejected,
})

export const authorizationGranted = (
  accessToken: string,
  username: string,
  manual = true,
): IAuthorizationGranted => ({
  accessToken,
  manual,
  type: AuthorizationActions.AuthorizationGranted,
  username,
})

export interface IAuthorizationGranted
  extends Action<AuthorizationActions.AuthorizationGranted> {
  accessToken: string
  username: string
  manual: boolean
}
